import type {AxiosRequestConfig} from 'axios';

import env from 'shared/constants/env';

export const DEFAULT_API_CONFIG: AxiosRequestConfig = {
  baseURL: env.JOURNEY_API_PATH,
};
